// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"204730f0","951":"c0dba6b2"}[chunkId] + ".chunk.js";
};